<template>
  <div class="loginPage">
    <v-container class="custom-container bg-register forgot-password">
      <v-row no-gutters>
        <v-col md="12">
          <div class="top-bar-register">
            <div class="logo-wrapper">
              <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
            </div>
            <LanguageMenu></LanguageMenu>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-5 mb-5" no-gutters>
        <v-col md="7" sm="9" cols="11">
          <h3 class="justify-center">Create New Account</h3>
          <v-form class="deposit-form password-field">
            <div class="form-details pt-0 pb-10">
              <template v-if="e1 === 1">
                <v-card-text class="text-center py-6">Write Your Basic Information</v-card-text>
                <fieldset v-for="field in fields" :key="field.name" :class="field.name === 'confirmPassword' ? 'margin-custom' : ''">

                  <legend>{{ field.legend }}</legend>
                  <v-text-field :placeholder="field.placeholder"
                    :type="field.type === 'password' ? (field.show ? 'text' : 'password') : field.type"
                    :append-icon="field.type === 'password' ? (field.show ? 'mdi-eye' : 'mdi-eye-off') : ''"
                    @click:append="field.show = !field.show" single-line solo hide-details
                    :value="registerInfo[field.name]" @input="(value) => REGISTER_INFO({ field: field.name, value })"
                    class="custom-select" :counter="field.counter">
                  </v-text-field>

                  <div v-if="passwordField && field.name === 'password'" class="mt-4">
                    <span v-for="(condition, index) in passwordConditions" :key="index" class="condition-items">
                      <v-icon small :class="condition.met ? 'text--green' : 'text--ash'">
                        mdi-check
                      </v-icon>
                      {{ condition.text }}
                    </span>
                  </div>

                </fieldset>

                <div class="mb-5">
                  <input type="checkbox" v-model="checkbox" class="custom-checkbox">
                  I Agree With Your<a class="text--green mx-1 under-line" target="_blank" :href="termsUrl"> Terms & Conditions</a>
                </div>

                <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                  @click.prevent="handleSendOTP"
                  :loading="loading"
                  :disabled="loading || !isEmailValid || !isPasswordFieldsValid || !arePasswordsMatching || !checkbox">
                  Send OTP
                </v-btn>
              </template>
              <template v-else>
                <div class="pt-5">
                  <fieldset>
                    <legend>OTP</legend>
                    <v-text-field placeholder="Enter OTP" single-line solo hide-details :value="registerInfo.otp"
                      @input="(value) => REGISTER_INFO({ field: 'otp', value })" class="custom-select"></v-text-field>
                  </fieldset>
                  <div class="px-0 pb-0">
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                          @click.prevent="e1 = 1">
                          Previous
                        </v-btn>
                      </v-col>
                      <v-col cols="8" class="pl-2">
                        <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile block elevation="0"
                          @click.prevent="handleRegister" :loading="loadingCreate" :disabled="!allConditionsMet || loadingCreate">
                          Create Account
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </template>
              <div class="another-link mt-10">
                <p>
                  Already have an account?
                  <router-link to="/">Log in</router-link>
                </p>
              </div>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center" class="mb-5">
        <v-col md="5">
          <p class="emailLink text-center">
            <strong>High Risk Investment Warning:</strong> Trading Leveraged
            Products such as Forex and Derivatives may not be suitable for all
            investors as they carry a high degree of risk to your capital. Please
            ensure that you fully understand the risks involved, taking into
            account your investments objectives and level of experience, before
            trading, and if necessary, seek independent advice.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";

export default {
  components: { LanguageMenu },

  data() {
    return {
      checkbox: false,
      loading: false,
      loadingCreate: false,
      termsUrl: window.location.origin + "/static/uploads/client_agreements/termsAndConditions.pdf",
      e1: 1,
      fields: [
        {
          name: "fname",
          legend: "First Name",
          placeholder: "John",
          type: "text",
        },
        {
          name: "lname",
          legend: "Last Name",
          placeholder: "Doe",
          type: "text",
        },
        {
          name: "email",
          legend: "Email",
          placeholder: "Write your email address",
          type: "email",
        },
        {
          name: "password",
          legend: "Password",
          placeholder: "Enter Here",
          type: "password",
          show: false,
          counter: true,
        },
        {
          name: "confirmPassword",
          legend: "Confirm Password",
          placeholder: "Write Password Again",
          type: "password",
          show: false,
          counter: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("register", ["registerInfo", "registrationError"]),
    ...mapGetters("register", ["isOtpSent", "isOtpVerified", "isRegistered"]),
    ...mapState("publicinfo", ["info"]),

    isEmailValid() {
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailRegex.test(this.registerInfo.email);
    },

    isPasswordFieldsValid() {
      return (
        this.registerInfo.password &&
        this.registerInfo.confirmPassword &&
        this.registerInfo.password.length > 0 &&
        this.registerInfo.confirmPassword.length > 0 &&
        this.passwordConditions.every((condition) => condition.met)
      );
    },

    arePasswordsMatching() {
      return (
        this.registerInfo.password === this.registerInfo.confirmPassword &&
        this.registerInfo.password !== '' &&
        this.registerInfo.confirmPassword !== ''
      );
    },

    passwordConditions() {
      const password = this.registerInfo.password || '';
      return [
        { met: password.length >= 8, text: "8 Characters" },
        { met: /[a-z]/.test(password), text: "1 Lowercase" },
        { met: /[A-Z]/.test(password), text: "1 Uppercase" },
        { met: /\d/.test(password), text: "1 Digit" },
        { met: /[@$!%*?&]/.test(password), text: "1 Special Character" },
      ];
    },

    allConditionsMet() {
      return (
        this.isPasswordFieldsValid &&
        this.arePasswordsMatching &&
        this.registerInfo.otp &&
        this.registerInfo.otp.length > 0
      );
    },

    passwordField() {
      return this.fields.find((field) => field.name === "password");
    },

    logoSrc() {
      return this.info?.logo_url || null;  // Changed from generalInfo to info
    },

    logoWidth() {
      return this.info?.logo_width || "50px";  // Changed from generalInfo to info
    },
    
    logoHeight() {
      return this.info?.logo_height || "50px";  // Changed from generalInfo to info
    }
  },
  methods: {
    ...mapMutations("register", {
      REGISTER_INFO: "SET_REGISTER_INFO",
    }),
    ...mapActions("register", ["sendOTP", "verifyOTP", "register", "initializeReferral"]),
    ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),

    async handleSendOTP() {
      try {
        this.loading = true;
        await this.sendOTP();
        this.e1 = 2
      } catch (error) {
        console.error("Error sending OTP:", error);
      }finally {
        this.loading = false;
      }
    },

    async handleRegister() {
      if (!this.allConditionsMet) return;
      try {
        this.loadingCreate = true;
        await this.verifyOTP();
        if (this.isOtpVerified) {
          await this.register();
          this.$router.push("/login");
        }
      } catch (error) {
        console.error("Error during registration:", error);
      }finally {
        this.loadingCreate = false;
      }
    },
  },

  async mounted() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.initializeReferral();
    
  },
};
</script>

<style scoped>
.margin-custom{
  margin-top: 75px;
 }
 
.condition-items {
  overflow: visible;
  font-size: 15px;
  align-items: center;
}

.custom-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  outline: none;
  cursor: pointer;
  border: 1px solid #3f546b;
  border-radius: 2px;
  background: #ffffff00;
  transition: background 0.3s, border-color 0.3s;
  margin-right: 8px;
  position: relative;
  top: 2px;
}
 
.custom-checkbox:checked {
  background: #131c29;
  border-color: #02b58a;
}
 
.custom-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: -9px;
  left: 2px;
  font-size: 20px;
}
 
.custom-checkbox:hover {
  border-color: #036d54 !important;
}
 
.custom-checkbox {
  border: 1px solid #02b58a;
}
 
.custom-checkbox:checked {
  background: #ffffff00;
  border-color: #02b58a;
}
 
.custom-checkbox:checked::after {
  color: #02b58a;
}
 
.custom-checkbox:hover {
  border-color: #02b58a;
}
</style>